import { mount } from 'svelte'
import Form from '@/components/keywords/edit/Form.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('keywords-form-app')
  if (el) {
    mount(
      Form,
      {
        target: el,
        props: {
          initialKeyword: el.dataset.keyword
        },
      })
  }
})
